export default {
    data() {
        return {
            response: null
        }
    },
    methods: {
        async getContent( documentType ) {

            if (this.$store.getters[`get${documentType.toUpperCase()}`]) {
                console.log('already in store')
                this.response = this.$store.getters[`get${documentType.toUpperCase()}`]
                return
            }

            console.log('not in store')
            const response = await this.$prismic.client.query(
                this.$prismic.predicates.at('document.type', documentType)
            )
            console.log('response', response)

            if(documentType === 'legals') {
                this.response = response.results[0].data.content
            } else {
                this.response = (documentType === 'header' || documentType === 'footer')
                    ? response.results[0].data
                    : response.results[0].data.body;
            }



            console.log('SET', `SET_${documentType.toUpperCase()}`)

            this.$store.commit(`SET_${documentType.toUpperCase()}`, this.response)
        },
    },
}
